export const UserRoles = [
  {
    key: 'none',
    text: 'None',
    value: 0,
    withoutEdit: 0,
  },
  // {
  //   key: 'service',
  //   text: 'Service',
  //   value: 700, //100
  //   withoutEdit: 700,
  // },
  // {
  //   key: 'admin',
  //   text: 'Admin',
  //   value: 800,
  //   withoutEdit: 800,
  // },
  {
    key: 'admin',
    text: 'Admin',
    value: 500, //400
    withoutEdit: 500,
  },
  {
    key: 'user',
    text: 'User',
    value: 200, //700
    withoutEdit: 200,
  },
  {
    key: 'advanced',
    text: 'Advanced',
    value: 300,
    withoutEdit: 300,
  },
]

// 'basic',            '',    '0001',   'en',  200
// 'advanced',         '',    '0002',   'en',  300
// 'manager',          '',    '0003',   'en',  400
// 'installer',        '',    '0004',   'en',  500
// 'partner',          '',    '0005',   'en',  600
// 'administrator',    '',    '5384',   'en',  700
// 'installer',        '',    '0800',   'en',  500
// 'service',          '',    '6000',   'en',  700
